<mat-card *ngIf="data && show" class="app-card-error" [class.mat-elevation-z9]="true">
  <mat-card-header>
    <mat-icon mat-card-avatar>error</mat-icon>
    <mat-card-title>{{data.message ? data.message : 'ERROR'}}</mat-card-title>
    <mat-card-subtitle>{{data.cause.error.details}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-actions>
    <button mat-button (click)="close()" i18n>CLOSE</button>
  </mat-card-actions>
</mat-card>
